import React from "react";
import styled from "styled-components";

import { GraphQLAPI, queries, WorkspaceWithLicense } from "@examspark/api";
import { Callout, VSpace } from "@examspark/common-ui";

const WorkspaceItem = styled.button`
  padding: 1rem;
  border-radius: 0.5rem;
  background-color: #fff;
  border: solid 1px #ddd;
  transition: all 0.2s ease-in-out;
  cursor: pointer;

  &:hover {
    border: solid 1px #aaa;
  }
`;

export const fetchWorkspaceAppLicense = async (
  appId: string,
  workspaceId: string,
) => {
  return (
    (await GraphQLAPI.query({
      query: queries.resource.getResource({
        fields: `id sk appKey workspaceId`,
      }),
      variables: {
        id: appId,
        sk: `app-license#${workspaceId}`,
      },
    })) as any
  )?.data?.getResource;
};

const LoginSelectWorkspace = (props: {
  workspaces: WorkspaceWithLicense[];
  onSelect: (workspace: WorkspaceWithLicense) => void;
}) => {
  return (
    <VSpace size="2rem">
      <Callout>
        It looks like you have access to this application through multiple
        Workspaces. Select the account you wish to access.
      </Callout>
      <VSpace style={{ gap: "0.5rem" }}>
        {props.workspaces.map((workspace) => {
          if (!workspace) return null;
          return (
            <WorkspaceItem
              key={workspace.id}
              id={workspace.id}
              onClick={async () => {
                props.onSelect(workspace);
              }}
            >
              {workspace.workspace?.name}
            </WorkspaceItem>
          );
        })}
      </VSpace>
    </VSpace>
  );
};

export default LoginSelectWorkspace;
